import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Divider } from 'grab-ui';

import { formatPrice } from '../../common/utils/currency';
import { PICKING_UP, DROPPING_OFF } from '../../constants/new-order-status';

import cashSvg from '../../public/images/cash.svg';
import styles from './cash-payment-card.less';

const CashPaymentCard = ({
  codAmount,
  symbol,
  deliveryFee,
  total,
  status,
  userType,
}) => {
  const { isSender, isReceiver } = userType;
  const showPaymentCard =
    (isSender && status === PICKING_UP) ||
    (isReceiver && status === DROPPING_OFF);

  if (!showPaymentCard || (!codAmount && !deliveryFee && !total)) return null;

  return (
    <div className={styles.container}>
      {deliveryFee && (
        <div className={styles.transaction}>
          <div className={styles.titleContainer}>
            <img src={cashSvg} alt="cash" />
            <p className={styles.title}>
              {isSender
                ? I18n.t('paymentCard.cashBySender')
                : I18n.t('paymentCard.cashByRecipient')}
            </p>
          </div>

          <p className={styles.amount}>
            {formatPrice({ amount: deliveryFee, symbol })}
          </p>
        </div>
      )}

      {codAmount && (
        <div className={styles.transaction}>
          <div className={styles.titleContainer}>
            <img src={cashSvg} alt="cash" />
            <p className={styles.title}>{I18n.t('paymentCard.cod')}</p>
          </div>

          <p className={styles.amount}>
            {formatPrice({ amount: codAmount, symbol })}
          </p>
        </div>
      )}

      {total && <Divider className={styles.divider} />}

      {total && (
        <div className={styles.transaction}>
          <div className={styles.titleContainer}>
            <p className={styles.title}>
              {total.startsWith('-')
                ? I18n.t('paymentCard.collect')
                : I18n.t('paymentCard.pay')}
            </p>
          </div>

          <p className={styles.total}>
            {formatPrice({ amount: total.replace(/-/, ''), symbol })}
          </p>
        </div>
      )}
    </div>
  );
};

CashPaymentCard.propTypes = {
  codAmount: PropTypes.string,
  symbol: PropTypes.string,
  deliveryFee: PropTypes.string,
  total: PropTypes.string,
  status: PropTypes.string,
  userType: PropTypes.shape({
    isReceiver: PropTypes.bool,
    isSender: PropTypes.bool,
  }),
};

CashPaymentCard.defaultProps = {
  codAmount: '',
  symbol: '',
  deliveryFee: '',
  total: '',
  status: '',
  userType: {
    isSender: false,
    isReceiver: true,
  },
};

export default CashPaymentCard;
